export default (props) => (
  /**
   * Ícone escala da cores degradê marrom.
   * Utilizada no dropdown "Escala de cores"
   * na edição de simbologia.
   */
  <svg
    width="176"
    height="22"
    viewBox="0 0 176 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.447266 3.42188C0.447266 1.76502 1.79041 0.421875 3.44727 0.421875H17.9643V21.8334H3.44727C1.79041 21.8334 0.447266 20.4902 0.447266 18.8334V3.42188Z"
      fill="#43221D"
    />
    <path
      d="M175.618 18.8359C175.618 20.4928 174.275 21.8359 172.618 21.8359L158.101 21.8359L158.101 0.424424L172.618 0.424425C174.275 0.424425 175.618 1.76757 175.618 3.42443L175.618 18.8359Z"
      fill="#F1ECE9"
    />
    <path
      d="M17.9648 0.421875H35.4819V21.8334H17.9648V0.421875Z"
      fill="#55312B"
    />
    <path
      d="M35.4814 0.421875H52.9985V21.8334H35.4814V0.421875Z"
      fill="#643E33"
    />
    <path
      d="M52.9985 0.421875H70.5156V21.8334H52.9985V0.421875Z"
      fill="#784B3E"
    />
    <path
      d="M70.5151 0.421875H88.0322V21.8334H70.5151V0.421875Z"
      fill="#845446"
    />
    <path
      d="M88.0327 0.421875H105.55V21.8334H88.0327V0.421875Z"
      fill="#986D62"
    />
    <path
      d="M105.55 0.421875H123.067V21.8334H105.55V0.421875Z"
      fill="#AB8980"
    />
    <path
      d="M123.066 0.421875H140.583V21.8334H123.066V0.421875Z"
      fill="#C5ACA7"
    />
    <path
      d="M140.584 0.421875H158.101V21.8334H140.584V0.421875Z"
      fill="#DCCDCA"
    />
  </svg>
);
